import { c as _c } from "react/compiler-runtime";
import { RiMapPin2Line } from "react-icons/ri";
import { cx } from "@/lib/tailwind-utils";

/**
 * Landing header shown on Reserve-with-Google entries so the clinic name,
 * location name, and full postal address are visible next to the selectable
 * services list — Google's Sandbox review requires all three to appear
 * together for the "Book" surface to be approved for production.
 *
 * Flat header block (no card chrome) — matches the rest of the self-schedule
 * flow's typography-first approach.
 */
export function RwgLandingBanner(t0) {
  const $ = _c(29);
  const {
    location,
    clinicName,
    className
  } = t0;
  let t1;
  if ($[0] !== location.addressLineOne || $[1] !== location.addressLineTwo) {
    t1 = [location.addressLineOne, location.addressLineTwo].filter(Boolean);
    $[0] = location.addressLineOne;
    $[1] = location.addressLineTwo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const streetLine = t1.join(", ");
  const t2 = location.city;
  let t3;
  if ($[3] !== location.state || $[4] !== location.zipCode) {
    t3 = [location.state, location.zipCode].filter(Boolean);
    $[3] = location.state;
    $[4] = location.zipCode;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = t3.join(" ");
  let t5;
  if ($[6] !== location.city || $[7] !== t4) {
    t5 = [t2, t4].filter(Boolean);
    $[6] = location.city;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const regionLine = t5.join(", ");
  let t6;
  if ($[9] !== regionLine || $[10] !== streetLine) {
    t6 = [streetLine, regionLine].filter(Boolean);
    $[9] = regionLine;
    $[10] = streetLine;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const addressParts = t6;
  let t7;
  if ($[12] !== clinicName || $[13] !== location.name) {
    t7 = Boolean(clinicName) && clinicName.trim() !== location.name.trim();
    $[12] = clinicName;
    $[13] = location.name;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const showClinicCaption = t7;
  let t8;
  if ($[15] !== className) {
    t8 = cx("mx-auto mb-6 max-w-3xl px-4 md:px-0", className);
    $[15] = className;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== clinicName || $[18] !== showClinicCaption) {
    t9 = showClinicCaption && <p className="text-caption uppercase tracking-wide text-foreground-muted">{clinicName}</p>;
    $[17] = clinicName;
    $[18] = showClinicCaption;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== location.name) {
    t10 = <h1 className="text-h3 font-semibold text-foreground">{location.name}</h1>;
    $[20] = location.name;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== addressParts) {
    t11 = addressParts.length > 0 && <p className="mt-1 flex items-start gap-1.5 text-caption text-foreground-secondary"><RiMapPin2Line className="mt-0.5 h-3.5 w-3.5 flex-none text-foreground-muted" aria-hidden={true} /><span>{addressParts.join(" \xB7 ")}</span></p>;
    $[22] = addressParts;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
    t12 = <header className={t8} aria-label="Booking location">{t9}{t10}{t11}</header>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}